import React, { useCallback } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'
import Button from 'components/Button'
import { actions, selectors, STEP } from '../../../duck'
import { RootActionType, RootState } from 'duck'
import { ReduxProps } from 'utils/Types'
import { dialogActions } from 'duck/AppDuck/DialogDuck'
import { values } from 'appConstants'
import { useBreakpoint } from 'utils/Hooks'
import Typography from 'components/Typography'
import stylesGlobal from 'stylesGlobal.module.scss'
import styles from '../../NFTSellForm.module.scss'

const mapStateToProps = (state: RootState) => ({
  gridCount: selectors.gridCount(state),
  notEnoughErrorText: selectors.notEnoughErrorText(state)
})

const mapDispatchToProps = (dispatch: Dispatch<RootActionType>) =>
  bindActionCreators(
    {
      closeDialog: dialogActions.closeDialog,
      setStep: actions.setStep,
      updateFormData: actions.updateFormData
    },
    dispatch
  )

type InfoCurateCollectionProps = ReduxProps<typeof mapStateToProps> &
  ReduxProps<typeof mapDispatchToProps>

const InfoCurateCollection: React.FC<InfoCurateCollectionProps> = props => {
  const { closeDialog, setStep, updateFormData, notEnoughErrorText, gridCount } = props

  const { isSmallscreenAbove } = useBreakpoint()
  const loading = gridCount === undefined
  const isImageLess = !loading && gridCount < values.MINIMUM_SELL_NFT_IMAGE

  const handleClose = useCallback(() => {
    closeDialog()
  }, [closeDialog])

  return (
    <div className={clsx('mx-auto', styles.FormfFreeformCurationWrapper)}>
      <div className="mb-8 text-center">
        <Typography variant="h5" className="mb-1.5">
          Step 1: Curate Your Collection
        </Typography>

        <Typography variant="subtitle2" className="text-white-med-on-dark">
          Select how you would like to sell this collection.
        </Typography>
      </div>

      <div className={clsx(isSmallscreenAbove && 'flex', 'mb-10')}>
        <div
          className={clsx(
            styles.CardCurateInfo,
            !isSmallscreenAbove && 'mb-10',
            isSmallscreenAbove && '!pr-8 !pt-6'
          )}
        >
          <div className="mb-9">
            <Typography variant="h6" className="mb-1">
              Artist Curated
            </Typography>

            <Typography variant="subtitle2" className="text-white-med-on-dark">
              You select which artworks to sell. Save the results you would like to sell. All
              artworks in the “<strong>SAVED</strong>” folder for this project will be sold to
              collectors.
            </Typography>
          </div>

          <Button
            className="mt-auto"
            disabled={loading || isImageLess}
            color="secondary"
            variant="contained"
            onClick={() => {
              updateFormData({ type: 'artist' })
              setStep(STEP.SELECT_COVER)
            }}
            fullWidth
          >
            CONTINUE
          </Button>
        </div>

        {isSmallscreenAbove ? <div className={stylesGlobal.BorderLeftOnSurface}></div> : null}

        <div className={clsx(styles.CardCurateInfo, isSmallscreenAbove && '!pl-8 !pt-6')}>
          <div className="mb-9">
            <Typography variant="h6" className="mb-1">
              Collector Curated
            </Typography>

            <Typography variant="subtitle2" className="text-white-med-on-dark">
              Collectors can buy any result generated from this model. All artworks in the "
              <strong>SAVED</strong>" folder for this project will be displayed as "Sample
              Generations".
            </Typography>
          </div>

          <Button
            className="mt-auto"
            disabled={true || loading || isImageLess}
            color="secondary"
            variant="contained"
            onClick={() => {
              updateFormData({ type: 'collector' })
              setStep(STEP.SELECT_COVER)
            }}
            fullWidth
          >
            COMING SOON
          </Button>
        </div>
      </div>

      {isImageLess ? (
        <Typography
          variant="caption"
          color="error"
          className="mt-auto pb-4"
          align="center"
          component="div"
        >
          {notEnoughErrorText}
        </Typography>
      ) : null}

      <Button variant="outlined" onClick={handleClose} fullWidth>
        GO BACK TO PROJECT
      </Button>
    </div>
  )
}
export default connect(mapStateToProps, mapDispatchToProps)(InfoCurateCollection)
